import { Link } from 'react-router-dom';

const footerLinks = {
  services: [
    { name: '内容创作', path: '/category/neirong-chuangzuo' },
    { name: '广告投放', path: '/category/guanggao-toufang' },
    { name: '品牌推广', path: '/category/pinpai-tuiguang' },
    { name: '数据分析', path: '/category/shuju-fenxi' },
  ],
  resources: [
    { name: '自媒体运营', path: '/category/zimeiti-yunying' },
    { name: '行业资讯', path: '/category/hangye-zixun' },
    { name: '创作者社区', path: '/about' },
    { name: '帮助中心', path: '/about' },
  ],
  company: [
    { name: '关于我们', path: '/about' },
    { name: '品牌故事', path: '/about' },
    { name: '加入我们', path: '/about' },
    { name: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="text-2xl font-heading font-bold text-background-50">
                  91<span className="text-primary-400">传媒</span>
                </span>
              </Link>
              <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-sm">
                91传媒是专注于数字内容传播与媒体服务的综合平台，为创作者与品牌主提供全方位的传媒解决方案。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/category/neirong-chuangzuo" className="hover:text-primary-400 transition-colors cursor-pointer">服务项目</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.services.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/category/zimeiti-yunying" className="hover:text-primary-400 transition-colors cursor-pointer">资源中心</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.resources.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于91传媒</a>
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 91传媒 版权所有 | 沪ICP备2025000000号
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">Cookie政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}